import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './navbar';
import Footerpage from './Footer';
import CountryFlags from './countrysection';

const Layout = ({ children }) => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

   // 👇 Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const marginTop = isHome ? '0px' : isMobile ? '20%' : '6%';

  return (
    <>
      <Navbar isHome={isHome} />
      <CountryFlags />
      <div style={{ marginTop }}>
        {children}
      </div>
      <Footerpage />
    </>
  );
};

export default Layout;
